<template>
  <el-dialog
    :title="getLanguageValue('分析报告')"
    :visible="dialogVisible"
    z-index="1000"
    :close-on-click-modal="false"
    width="fit-content"
    :before-close="handleClose"
    class="result-dialog"
  >
    <div class="result-container">
      <div class="flex-row" style="justify-content: center;">
        <div
          v-for="(item, index) of downLoadList"
          :key="index"
          :class="['result-item', index !== downLoadList.length-1 ? 'border-right' : '']"
        >
          <div class="img-container">
            <img :src="item.imgSrc" :alt="getLanguageValue(item.imgAlt)" />
          </div>
          <div class="file-name">{{ item.fileName }}</div>
          <el-button type="primary" @click="downLoadFile(item)" class="download-btn">
            {{getLanguageValue(item.btnText)}}
          </el-button>
        </div>
      </div>
      <div class="download-container flex-row" v-if="pdfFile">
        <i class="el-icon-question" style="margin-right: 5px; font-size: 18px;" />
        PPT文件在WPS中打开展示效果更佳，如果出现展示问题，请另外
        <el-popover
          v-model="downloadLoading"
          placement="bottom"
          width="400"
          trigger="manual"
        >
          <generate-loading
            :show="downloadLoading"
            loadingText="预计1-3分钟，请耐心等待~"
            :loadingTime="120000"
          />
          <el-button slot="reference" size="mini" type="primary" style="margin-left: 5px;" @click="downloadPDF">{{getLanguageValue('下载PDF报告')}}</el-button>
        </el-popover>  
      </div>
      </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { generatePdfReport } from '@/api/product';
import GenerateLoading from './generate-loading.vue'

export default {
  name: 'ResultDialog',
  props: {
    formData: Object,
    analyType: String,
  },
  components:{
    GenerateLoading,
  },
  data() {
    return {
      dialogVisible: false,
      wordData: null,
      pptData: null,
      sourceDownLodList: [],
      downLoadList: [],
      downloadLoading: false,
    }
  },
  computed: {
    ...mapGetters("language", ["getLanguageValue"]),
    ...mapState({
      currentLanguage: (state) => state.language.languageType, // 映射 languageType
    }),
    pdfFile() {
      const { sourceDownLodList } = this
      return sourceDownLodList.find(item => item.fileType === 'pdf')
    },
  },
  methods: {
    // 生成pdf报告
    downloadPDF() {
      this.downloadLoading = true
      generatePdfReport(this.pdfFile).then(res => {
        if (res.success) {
          if (res.data.hasSuccess) {
            this.$message.success(this.getLanguageValue('生成成功'))
            if(res.data) this.downLoadFile(res.data)
          } else {
            this.$message.success(this.getLanguageValue('pdf正在生成中'))
          }
        } else {
          this.$message.error(this.getLanguageValue(res.message))
        }
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    // 文件名
    getFileName(type) {
      const date = new Date();
      const fileName = `${this.formData?.companyName}_${
        this.formData.projectName
    }${this.getLanguageValue(`${this.analyType}分析报告`)}_${date.getHours()}:${date.getMilliseconds()}.${type}`;
      return fileName;
    },
    show(arr = []) {
      this.sourceDownLodList = arr
      const filterDocuTypes = this.currentLanguage === '中文' ? ['pdf'] : ['pdf', 'docx']
      const data = arr.filter(item => !filterDocuTypes.includes(item.fileType))
      const fileTypeConfig = {
        docx: {
          imgSrc: require('@/assets/img/word.svg'),
          imgAlt: 'Word文档',
          btnText: '下载Word报告',
        },
        pptx: {
          imgSrc: require('@/assets/img/ppt.svg'),
          imgAlt: 'PPT文档',
          btnText: '下载PPT报告',
        },
        pdf: {
          imgSrc: require('@/assets/img/pdf.svg'),
          imgAlt: 'PDF文档',
          btnText: '下载PDF报告',
        },
      }

      // 遍历时动态设置属性
      data.forEach(item => {
        const config = fileTypeConfig[item.fileType]
        if (config) {
          Object.assign(item, config)
        }
      })
      const order = ['docx','pptx']
      data.sort((a, b) => {
        const indexA = order.indexOf(a.fileType)
        const indexB = order.indexOf(b.fileType)
        return indexA - indexB
      })
      this.downLoadList = data;
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.downloading = false
    },
    downLoadFile(fileItem) {
      const origin = location.origin;
      const url = new URL(
        `${origin}/api/file/downloadReport/${
          fileItem.filePath
        }`,
        location.origin
      );
      window.open(url.href);
    },
  }
}
</script>
<style lang="less" scoped>
.result-container {
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  min-width: 480px;
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .border-right {
    border-right: 1px solid #DCDFE6;
  }
  .result-item {
    width: 240px;
    padding: 0 20px 60px 20px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .img-container {
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
    .file-name {
      width: 100%;
      text-align: center;
      color: #606266;
      font-size: 14px;
      white-space: pre-wrap;
      word-break: break-all;
      line-height: 1.4;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .download-btn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 160px;
    }
  }
}
// 覆盖element-ui的默认样式
:deep(.el-dialog__body) {
  padding: 0;
}
</style>
